import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _defineProperty from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _im;

import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
var txim = null;
var im = (_im = {
  TIM: TIM,
  TIMUploadPlugin: TIMUploadPlugin,
  sdkAppId: Number(process.env.VUE_APP_IM_SDK),
  adminId: 'custom_service',
  //当前账号id
  sdkStateReady: false,
  _p: function _p(cb) {
    return new Promise(cb);
  },
  _eventMap: {},
  // 获取实例 - 虚构方法
  getInstance: function getInstance() {
    return im;
  },
  setAdminId: function setAdminId(id) {
    return im._p( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                im.adminId = id;
                next();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  // 初始化SDK
  initSDK: function initSDK(sdkAppID, sdkConfig) {
    var _this = this;

    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    sdkAppID = sdkAppID || im.sdkAppId;
    sdkConfig = sdkConfig || {
      SDKAppID: sdkAppID
    };

    var _cb = function _cb(res) {
      if (res.name && _typeof(res) === 'object') {
        switch (res.name) {
          case TIM.EVENT.CONVERSATION_LIST_UPDATED:
            app.$store.dispatch('d2admin/message/tximConversationList', res.data);
            break;

          case TIM.EVENT.MESSAGE_RECEIVED:
            // app.$store.dispatch('d2admin/message/tximConversationList', res.data)
            break;

          case TIM.EVENT.SDK_READY:
            _this.sdkStateReady = true;
            app.$store.dispatch('d2admin/message/isImLogin', true);
            break;

          case TIM.EVENT.KICKED_OUT:
            alert('您的账号在别处登录');
            app.$store.dispatch('d2admin/message/isImLogin', false);
            app.$store.dispatch('d2admin/account/logout');
            break;

          default:
            break;
        }
      }
    };

    txim = TIM.create(sdkConfig, _cb);
    txim.setLogLevel(4); //注册插件

    txim.registerPlugin({
      'tim-upload-plugin': TIMUploadPlugin
    });
    im.onSdkReady(_cb);
    im.addSimpleMsgListener(_cb);
    im.setConversationListener(_cb);
    im.onKickedOut(_cb);
  },
  // 销毁 SDK
  unInitSDK: function unInitSDK() {
    txim.destroy();
  },
  //确认sdk是否准备完毕
  isSdkReady: function isSdkReady() {
    var _this2 = this;

    if (this.sdkStateReady) return Promise.resolve();
    return new Promise(function (r, j) {
      var i = 1;
      var timer = setInterval(function () {
        i++;
        if (_this2.sdkStateReady) r(clearInterval(timer));

        if (i > 100 * 50) {
          clearInterval(timer);
          alert('网络异常');
        }
      }, 100);
    });
  },
  //获取个人资料
  getMyProfile: function getMyProfile(callback) {
    var _this3 = this;

    return im._p( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(next) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.isSdkReady();

              case 2:
                _context2.next = 4;
                return txim.getMyProfile();

              case 4:
                res = _context2.sent;
                callback && callback(res.data);
                next(res.data);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  // 添加全局事件监听
  $on: function $on(eventType, callback) {
    im._eventMap[eventType] = im._eventMap[eventType] || [];

    im._eventMap[eventType].push(callback);

    txim.on(TIM.EVENT[eventType], callback);
  },
  // 删除全局事件监听
  $off: function $off(eventType, callback) {
    im._eventMap[eventType] = im._eventMap[eventType] || [];

    var index = im._eventMap[eventType].indexOf(callback);

    if (index >= 0) {
      im._eventMap[eventType].splice(index, 1);

      txim.off(TIM.EVENT[eventType], callback);
    }
  },
  //监听被踢下线
  onKickedOut: function onKickedOut(cb) {
    txim.on(TIM.EVENT.KICKED_OUT, cb);
  },
  //监听sdk处于ready状态
  onSdkReady: function onSdkReady(cb) {
    txim.on(TIM.EVENT.SDK_READY, cb);
  },
  // 设置基本消息（文本消息和自定义消息）的事件监听器
  addSimpleMsgListener: function addSimpleMsgListener(cb) {
    txim.on(TIM.EVENT.MESSAGE_RECEIVED, cb);
  },
  // 设置会话监听器
  setConversationListener: function setConversationListener(cb) {
    txim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, cb);
  },
  // 移除基本消息（文本消息和自定义消息）的事件监听器
  removeSimpleMsgListener: function removeSimpleMsgListener() {
    txim.off(TIM.EVENT.MESSAGE_RECEIVED);
  },
  // 登录
  login: function login(userSig, callback) {
    return im._p( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(next) {
        var config, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                config = {
                  userID: im.adminId,
                  userSig: userSig
                };
                _context3.next = 3;
                return txim.login(config);

              case 3:
                res = _context3.sent;
                callback && callback(res);
                next();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  // 登出
  logout: function logout(callback) {
    return im._p( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(next) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return txim.logout();

              case 2:
                res = _context4.sent;
                app.$store.dispatch('d2admin/message/isImLogin', false);
                app.$store.dispatch('d2admin/message/isImShow', false);
                app.$store.dispatch('d2admin/message/isImFormId', '');
                callback && callback(res);
                next();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
  },
  // 获取会话列表
  getConversationList: function getConversationList() {
    return im._p(function (next) {
      next(txim.getConversationList());
    });
  }
}, _defineProperty(_im, "getConversationList", function getConversationList() {
  return im._p(function (next) {
    next(txim.getConversationList());
  });
}), _defineProperty(_im, "markC2CMessageAsRead", function markC2CMessageAsRead(userID, callback) {
  return im._p( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(next) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return txim.setMessageRead({
                conversationID: userID
              });

            case 2:
              next();

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }());
}), _defineProperty(_im, "getC2CHistoryMessageList", function getC2CHistoryMessageList(userID) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var lastMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var callback = arguments.length > 3 ? arguments[3] : undefined;
  var options = {
    conversationID: userID,
    count: count,
    nextReqMessageID: lastMsg
  };
  return im._p(function (next) {
    next(txim.getMessageList(options));
  });
}), _defineProperty(_im, "_build_advanced_msg", function _build_advanced_msg(userID, payload) {
  return {
    to: userID,
    conversationType: TIM.TYPES.CONV_C2C,
    payload: payload
  };
}), _defineProperty(_im, "createTextMessage", function createTextMessage(userID, text, callback) {
  var uid = userID.indexOf('C2C') >= 0 ? userID.replace('C2C', '') : userID;
  return im._p( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(next) {
      var msg;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return txim.createTextMessage(im._build_advanced_msg(uid, {
                text: text
              }));

            case 2:
              msg = _context6.sent;
              next(msg);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }());
}), _defineProperty(_im, "sendMessage", function sendMessage(message) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  return im._p( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(next) {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              next(txim.sendMessage(message, _objectSpread({}, config)));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }());
}), _defineProperty(_im, "addFriend", function addFriend(userID, callback) {
  var config = {
    to: userID,
    source: 'AddSource_Type_Web'
  };
  return im._p( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(next) {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              next(txim.addFriend(config));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }());
}), _defineProperty(_im, "getFriendList", function getFriendList(callback) {
  return im._p( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(next) {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              next(txim.getFriendList());

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }());
}), _defineProperty(_im, "setMessageType", function setMessageType(msg) {
  var _msg$payload;

  var str = {
    type: 'textdir',
    content: ''
  };

  switch (msg.type) {
    case TIM.TYPES.MSG_TEXT:
      str = {
        type: 'textdir',
        content: (_msg$payload = msg.payload) === null || _msg$payload === void 0 ? void 0 : _msg$payload.text,
        isPeerRead: msg.isPeerRead,
        flow: msg.flow == 'in'
      };
      break;

    case TIM.TYPES.MSG_IMAGE:
      str = {
        type: 'image',
        content: msg.payload.imageInfoArray[0].url,
        isPeerRead: msg.isPeerRead,
        flow: msg.flow == 'in'
      };
      break;

    case TIM.TYPES.MSG_VIDEO:
      var _msg$payload2 = msg.payload,
          thumbUrl = _msg$payload2.thumbUrl,
          videoUrl = _msg$payload2.videoUrl;
      str = {
        type: 'video',
        content: thumbUrl,
        videoUrl: videoUrl,
        isPeerRead: msg.isPeerRead,
        flow: msg.flow == 'in'
      };
      break;

    default:
      break;
  }

  return str;
}), _im);
export default im;